/** Общие помощники текстов окон. */
export function nameKey(kind: "boost" | "hero", id: string): string {
  return kind === "boost" ? `boost.${id.replace(/^boost_/, "")}` : `hero.${id}`;
}
